import {SurfaceEditorConfirmExportModal} from '#components';

export function useSurfaceEditorExport({exportHandler, onExport} = {}) {

  function getExportErrorMessage(error) {
    if (error?.message === 'STORAGE_FULL' || error?.response?.status === 413 || error?.statusCode === 413) {
      return 'We could not apply this image because your FOREVER Storage account is full.';
    }
    return 'We ran into an issue applying this image. Please try again.';
  }

  async function handleExport({project, conf, exportSurface, exportAllSurfaces}) {
    const exportedSurface = await exportSurface();
    const actionText = conf?.exportActionText || 'Save';

    const confirmProps = reactive({
      exported: exportedSurface.blob,
      actionText,
      errorMessage: '',
      isSaving: false
    });

    const confirm = useFModal({
      id: 'surface-editor-confirm-export',
      size: 'md',
      clickToClose: false,
      escToClose: false,
      component: SurfaceEditorConfirmExportModal,
      props: confirmProps,
      eventHandlers: {
        async confirm() {
          if (confirmProps.isSaving) return;
          confirmProps.isSaving = true;
          confirmProps.errorMessage = '';

          try {
            const context = {project, conf, exportSurface, exportAllSurfaces, exportedSurface};
            const exportResult = await exportHandler(context);

            if (typeof onExport === 'function') {
              await onExport(exportResult, context);
            }

            confirm.close();
          } catch (e) {
            confirmProps.errorMessage = getExportErrorMessage(e);
          } finally {
            confirmProps.isSaving = false;
          }
        }
      }
    });
    confirm.open();
  }

  return {handleExport};
}
